// import { useEffect, useState } from "react";

function CompScroll({ value }) {
  
  // const [swiper, setSwiper] = useState(null);
  // const down = true;
  
  // useEffect(() => {
  //   const swiperInstance = document.querySelector(".main-swiper").swiper;

  //   setSwiper(swiperInstance);
  // }, []);

  // const onMovePage = () => {
  //   if (typeof swiper === "object") {
  //     if (down) {
  //       swiper.pagination.update();
  //     } 
  //   }
  // };
  // onClick={onMovePage}

  return (
    <>
      <button className="slider-scroll-btn">
        <span className="scroll-wrap">
          <span className="scroll-title">Scroll</span>
          <span className="scroll-circle"></span>
        </span>
      </button>
    </>
  );
}

export default CompScroll;
